import { useEffect, useState } from 'react';

export const DMS_APP_URL = 'https://qa.nuostack.comptivia.com';

const STORAGE_KEY = 'dmsIntegrationEnabled';
const CHANGE_EVENT = 'dms-integration-changed';

export const isDmsEnabled = () => localStorage.getItem(STORAGE_KEY) === '1';

export const setDmsEnabled = (on: boolean) => {
  if (on) localStorage.setItem(STORAGE_KEY, '1');
  else localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

/** Stays in step with the Integration switch, including on another tab. */
export const useDmsEnabled = () => {
  const [on, setOn] = useState(isDmsEnabled);

  useEffect(() => {
    const sync = () => setOn(isDmsEnabled());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return on;
};
